export const OnlineCertificatesPage = {
  en: {
    'Online Certificates': 'Online Certificates',
  },
  uk: {
    'Online Certificates': 'Онлайн сертифікати',
  },
};

export const OnlineCertificatePage = {
  en: {},
  uk: {},
};
